export default __webpack_public_path__ + "static/media/image-02.49f4212b.jpg";